module.exports = __webpack_public_path__ + "assets/img/header-blogue-la-cartoucherie.28e39eb4.jpg";